import { motion } from "framer-motion";
import { Mail } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const fieldClass =
  "w-full bg-[#0A0A0C] border border-white/15 px-4 py-3 text-sm text-white placeholder:text-[#71717A] font-light focus:outline-none focus:border-[#FFD166] transition-colors duration-200";

const ContactForm = ({ contact, emailError, onChange, onSubmit }) => (
  <motion.div
    key="contact"
    initial={{ opacity: 0, x: 24 }}
    animate={{ opacity: 1, x: 0 }}
    exit={{ opacity: 0, x: -24 }}
    transition={{ duration: 0.5, ease: EASE }}
    data-testid="detector-contact-step"
    className="relative bg-[#121214] border-2 border-[#FFD166]/70 p-6 sm:p-8"
  >
    <div className="flex items-center gap-3 mb-2">
      <Mail size={18} className="text-[#FFD166]" />
      <h2 className="font-display font-semibold text-xl sm:text-2xl text-white">
        Send Me My Claim Check
      </h2>
    </div>
    <p className="text-sm text-[#A1A1AA] font-light">Results are sent via email.</p>

    <form onSubmit={onSubmit} className="mt-6 space-y-5" noValidate>
      <div>
        <label
          htmlFor="detector-first-name"
          className="block font-mono-file text-[10px] tracking-[0.2em] text-white/70 uppercase mb-2"
        >
          First name (optional)
        </label>
        <input
          id="detector-first-name"
          data-testid="detector-first-name-input"
          type="text"
          placeholder="First name"
          value={contact.firstName}
          onChange={(e) => onChange("firstName", e.target.value)}
          className={fieldClass}
        />
      </div>

      <div>
        <label
          htmlFor="detector-email"
          className="block font-mono-file text-[10px] tracking-[0.2em] text-white/70 uppercase mb-2"
        >
          Email address <span className="text-[#E63946]">*</span> (Required)
        </label>
        <input
          id="detector-email"
          data-testid="detector-email-input"
          type="email"
          required
          placeholder="you@example.com"
          value={contact.email}
          onChange={(e) => onChange("email", e.target.value)}
          className={fieldClass}
        />
        {emailError && (
          <p data-testid="detector-email-error" className="mt-2 text-xs text-[#E63946] font-light">
            {emailError}
          </p>
        )}
      </div>

      <button
        type="submit"
        data-testid="detector-submit-btn"
        className="group w-full inline-flex items-center justify-center gap-3 bg-[#FFD166] text-black font-display text-sm tracking-[0.18em] px-7 py-4 shadow-[5px_5px_0_#8A2BE2] hover:bg-[#F5CB5C] hover:shadow-[3px_3px_0_#8A2BE2] hover:translate-x-[2px] hover:translate-y-[2px] transition-[background-color,box-shadow,transform] duration-200"
      >
        SEND MY RESULTS
      </button>
    </form>
  </motion.div>
);

export default ContactForm;
